import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const memoryLoss: AnswerPathTreeNode = {
  path: 'memoryLoss',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredMemoryLossDetails }],
};
